<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="复制账户" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
			<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
				<el-form
				:inline="true"
				size="mini"
				>
			    <el-form-item label="请输入复制源ID">
			      <el-input v-model="searchForm.advertiser_id" placeholder="请输入复制源ID"></el-input>
			    </el-form-item>
			    <el-form-item>
			      <el-button type="primary" @click="doSearch">查询</el-button>
			      <el-button type="primary" @click="reset">重置</el-button>
			    </el-form-item>
				</el-form>
			</div>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <el-button type="primary" :size="size" @click="openCopy">复制账户</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table :data="tableData.data" border style="width: 100%">
                  <el-table-column prop="id" fixed label="任务ID" width="80"></el-table-column>
                  <!-- <el-table-column prop="task_type" label="任务类型" min-width="150"></el-table-column> -->
				  <el-table-column prop="advertiser_id" label="复制广告主ID" min-width="220"></el-table-column>
				  <el-table-column prop="copy_type" label="命名类型" min-width="150"></el-table-column>
				  <el-table-column prop="copy_name" label="账户名称" min-width="220"></el-table-column>
                  
                  <el-table-column prop="total" label="执行进度" min-width="150">
                    <template slot-scope="scope">
                      <span style="font-weight: bold">{{scope.row.progress+"/"+scope.row.total}}</span>
                    </template>
                  </el-table-column>
				  <el-table-column prop="err_num" label="失败数" width="200"></el-table-column>
				  <el-table-column prop="status_str" label="执行状态" width="150"></el-table-column>
				  <el-table-column prop="message" label="信息" min-width="150"></el-table-column>
				  <el-table-column prop="uid_name" label="创建人" min-width="150"></el-table-column>
                  <el-table-column prop="create_time" label="创建时间" min-width="200"></el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
	<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="50%">
	  <el-form :model="addForm" ref="addForm" label-width="140px" :size="size" :rules="rules.addForm">
	    <div class="drawer-header">
	      <div class="header-title">
	        <span>复制账户</span>
	        <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
	      </div>
	    </div>
	    <div class="drawer-content">
	      <el-form-item label="代理商ID:" prop="agent_id">
	        <el-select
	          style="width: 100%"
	          v-model="addForm.agent_id"
	          filterable
	          remote
	          reserve-keyword
	          placeholder="请选择代理商ID"
	          :remote-method="getAgentId"
	        >
	          <el-option
	            v-for="item in options.agent_id"
	            :key="item.agent_id"
	            :label="item.agent_name"
	            :value="item.agent_id"
	          ></el-option>
	        </el-select>
	      </el-form-item>
	      <el-form-item label="广告主ID:" prop="advertiser_id">
	        <el-input placeholder="请输入广告主ID" v-model="addForm.advertiser_id"></el-input>
	      </el-form-item>
	      <template v-if="addForm.agent_id_type == 'TouTiao'">
	      	<el-form-item label="是否复制头像:">
	      		<el-radio-group v-model="addForm.is_copy_head_cover" @change="changeYyType('editForm')">
	      			<el-radio v-for="item in options.yorn" :key="item.value"
	      				:label="item.value">{{ item.label }}</el-radio>
	      		</el-radio-group>
	      	</el-form-item>
	      	<el-form-item label="报备类型:">
	      		<el-radio-group v-model="addForm.report_type" @change="changeYyType('editForm')">
	      			<el-radio v-for="item in options.report_type" :key="item.value"
	      				:label="item.value">{{ item.label }}</el-radio>
	      		</el-radio-group>
	      	</el-form-item>
	      	<el-form-item label="是否复制投放资质:">
	      		<el-radio-group v-model="addForm.copy_delivery" @change="changeYyType('editForm')">
	      			<el-radio v-for="item in options.yorn" :key="item.value"
	      				:label="item.value">{{ item.label }}</el-radio>
	      		</el-radio-group>
	      	</el-form-item>
	      	<el-form-item label="是否复制标签:">
	      		<el-radio-group v-model="addForm.copy_tag" @change="changeYyType('editForm')">
	      			<el-radio v-for="item in options.yorn" :key="item.value"
	      				:label="item.value">{{ item.label }}</el-radio>
	      		</el-radio-group>
	      	</el-form-item>
	      </template>
	      <el-form-item label="账户名称命名类型:" prop="copy_type">
	      	<el-radio-group v-model="addForm.copy_type">
	      		<el-radio v-for="item in options.copy_type" :key="item.value"
	      			:label="item.value">{{ item.label }}</el-radio>
	      	</el-radio-group>
	      	<p style="color:#409EFF; line-height:20px; font-size:12px; margin-top:5px;">注：(自定义模式下,自定义开户名-(规则)-顺序序号生成。例:北京自定义有限公司-规则-1、北京自定义有限公司-规则-2...)</p>
	      </el-form-item>
	      <template v-if="addForm.copy_type == 2">
	      	<el-form-item prop="copy_name">
	      		<el-checkbox-group v-model="addForm.guize" @change="changeGuize">
	      			<el-checkbox label="Y">年</el-checkbox>
	      			<el-checkbox label="M">月</el-checkbox>
	      			<el-checkbox label="D">日</el-checkbox>
	      			<el-checkbox label="st_num" disabled checked>序号</el-checkbox>
	      		  </el-checkbox-group>
	      		  <el-input placeholder="请输入自定义名称" v-model="addForm.copy_name"></el-input>
	      		  <p style="color:#409EFF; line-height:20px; font-size:12px; margin-top:5px;" v-if="name">（名称预览）媒体后台：{{name}};</p>
	      	  </el-form-item>
	      </template>
	      <el-form-item label="开始序列号:" prop="start_num">
	        <el-input-number v-model="addForm.start_num" :min="1" :max="500"></el-input-number>
	      </el-form-item>
	      <el-form-item label="复制数量:" prop="number">
	        <el-input-number v-model="addForm.number" :min="1" :max="500"></el-input-number>
	      </el-form-item>
	    </div>
	    <div class="drawer-footer">
	      <el-button type="primary" @click="copyAccount" :size="size">提 交</el-button>
	      <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
	    </div>
	  </el-form>
	</el-drawer>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      timer: '',
      dialogTableVisible: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      searchForm: {
        advertiser_id: ''
      },
      resetSearch: {
        advertiser_id: ''
      },
      checked: false,
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      taskId: '',
      infoData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
	  loading:false,
	  addFormVisiable:false,
	  addForm:{
	  		  agent_id:'',
	  		  agent_id_type:'',
	  		  advertiser_id:'',
	  		  copy_type:1,
	  		  start_num:'',
	  		  number:'',
	  		  is_copy_head_cover:1,
	  		  report_type:'EMPTY',
	  		  copy_delivery:2,
	  		  copy_tag:2,
	  		  copy_name:'',
	  		  guize:[]
	  },
	  name:'',
	  options:{
		  agent_id:[],
		  report_type:[
			  {
				  label:'不报备',
				  value:'EMPTY'
			  },
			  {
				  label:'自运营报备',
				  value:'SELF_OPERATION'
			  },
			  {
				  label:'走量报备',
				  value:'ASCEND_REPORT'
			  },
			  {
				  label:'收量报备',
				  value:'DESCEND_REPORT'
			  }
		  ],
		  yorn:[
			  {
				  label:'是',
				  value:1
			  },
			  {
				  label:'否',
				  value:2
			  }
		  ],
		  copy_type:[
			  {
				  label:'自动',
				  value:1
			  },
			  {
				  label:'自定义',
				  value:2
			  }
		  ]
	  },
	  rules: {
	    addForm: {
		  'agent_id': [
			  {required: true, message: '请选择代理商ID', trigger: ['blur','change']},
		  ],
		  'advertiser_id': [
			  {required: true, message: '请输入广告主ID', trigger: ['blur','change']},
		  ],
		  'start_num': [
			  {required: true, message: '请输入开始序列号', trigger: ['blur','change']},
		  ],
		  'number': [
			  {required: true, message: '请输入复制数量', trigger: ['blur','change']},
		  ],
		  'copy_name': [
				{required: true, message: '请输入自定义开户名称', trigger: ['blur','change']}
		  ],
		  'copy_type': [
				{required: true, message: '请选择账户名称命名类型', trigger: ['blur','change']},
		  ],
		},
	}
    }
  },
  watch: {
    'addForm.agent_id'(newVal) {
      if (!newVal) return;
      const selectedAgent = this.options.agent_id.find(item => item.agent_id === newVal);
  
      if (selectedAgent) {
        this.addForm.agent_id_type = selectedAgent.media_type;
      }
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch()
    next()
  },
  mounted: function() {
    var params = this.makeParams()
    this.handleSearch()
	this.getAgentId()
  },
  methods: {
    reset: function() {
      this.searchForm = this.resetSearch
      this.doSearch()
    },
    resetStatus: function() {
      this.searchForm.status = ''
    },
    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())
    
      this.$router.push({ path: this.$route.path, query: query })
    },
    
    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },
    
    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },
    // 公共请求接口
    handleSearch: function(params, page, prop, order) {
      this.loading = true
      var param = {}
      param['advertiser_id'] = this.searchForm.advertiser_id
        ? this.searchForm.advertiser_id
        : this.resetSearch.advertiser_id
      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'
      this.$api.adPromotion.getCopyTasklist(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
	openCopy(){
		this.addForm = {
			agent_id:'',
			agent_id_type:'',
			advertiser_id:'',
			copy_type:1,
			start_num:'',
			number:'',
			is_copy_head_cover:1,
			report_type:'EMPTY',
			copy_delivery:2,
			copy_tag:2,
			copy_name:'',
			guize:[]
		}
		this.addFormVisiable = true
		this.$nextTick(() => {
			this.$refs['addForm'].clearValidate();
		});
	},
	copyAccount(){
		this.$refs['addForm'].validate(
		  function(valid) {
		    if (valid) {
		      this.$api.adPromotion.addAgentTask(this.addForm).then(res => {
		        if (res.code === 0) {
				  this.handleSearch(this.searchForm,1)
				  this.addFormVisiable = false
				  this.$message({
				    showClose: true,
				    message: '账户复制成功！',
				    type: 'success'
				  })
		        }else{
					this.$message({
					  showClose: true,
					  message: res.msg,
					  type: 'warning'
					})
				}
		      })
		    } else {
		      this.$message({
		        showClose: true,
		        message: '请填写正确的信息！',
		        type: 'warning'
		      })
		    }
		  }.bind(this)
		)
	},
	getAgentId: function(query, type) {
	  this.$api.adPromotion.getAgentId({ agent_id: query }).then(res => {
	    if (res.code === 0) {
	     this.options.agent_id = res.data
	    }
	  })
	},
	changeGuize(){
		let checkbox_arr = []
		const now = new Date()
		var selectedValues = this.addForm.guize.map(function (value) {
				return value
			})
		let txt = ''
		if (selectedValues.includes('Y')) {
			txt += now.getFullYear().toString().slice(-2)
		}
		if (selectedValues.indexOf('M') != -1) {
			txt += now.getMonth() + 1
		}
		if (selectedValues.indexOf('D') != -1) {
			txt += now.getDate()
		}
		if (txt) {
			checkbox_arr.push(txt)
		}
		var checkbox_new = [...checkbox_arr, ...[123]]
		this.name = checkbox_new.join('-')
	},
    // 生成查询参数
    makeParams: function(query, data) {
      var params = {}
      params['advertiser_id'] = this.searchForm.advertiser_id
        ? this.searchForm.advertiser_id
        : this.resetSearch.advertiser_id
      this.searchForm = params
      return params
    }
  }
}
</script>